function dm_hero() {
    "use strict";

    // hero allows for desktop and mobile crops of videos. Remove the unrequired tag to prevent duplicate streaming

    let $vimeo_desktop = $('section.hero #vimeo-player'), $vimeo_mobile = $('section.hero #vimeo-player-mobile');
    let $vimeo_desktop_placeholder = $('section.hero .bg img.placeholder'), $vimeo_container = $('section.hero .video-bg.bg');
    let $ww = $(window).width();
    const $isMobile = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

    if ($vimeo_desktop.length && $vimeo_mobile.length) {
        if ($isMobile && $ww < 1023) {
            $vimeo_desktop.remove();
            $vimeo_desktop_placeholder.remove();
            $vimeo_container.addClass('mobile-video');
        } else {
            $vimeo_mobile.remove();
        }
    }
}
export { dm_hero };